import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import createStore from './redux/create-store';
import App from './App';
import { unregister } from './registerServiceWorker';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-select/dist/react-select.min.css';
import 'carbon-components/css/carbon-components.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/main.css';
import 'video-react/dist/video-react.css';

const { store } = createStore();

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js